module.exports = __webpack_public_path__ + "img/icon-population.f6bf2ed9.svg";